import { render, staticRenderFns } from "./detailReservationCard.vue?vue&type=template&id=c6af9112&scoped=true"
import script from "./detailReservationCard.vue?vue&type=script&lang=js"
export * from "./detailReservationCard.vue?vue&type=script&lang=js"
import style0 from "./detailReservationCard.vue?vue&type=style&index=0&id=c6af9112&prod&scoped=true&lang=css"
import style1 from "./detailReservationCard.vue?vue&type=style&index=1&id=c6af9112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6af9112",
  null
  
)

export default component.exports